import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
type ShapeProps = {
  className?: string;
  color?: 'coral' | 'navy' | 'white';
  size?: number;
  delay?: number;
};
export const RotatingSquare = ({
  className = '',
  color = 'coral',
  size = 100,
  delay = 0
}: ShapeProps) => {
  const bgColor = color === 'coral' ? 'bg-coral' : color === 'navy' ? 'bg-navy' : 'bg-white';
  return <motion.div className={`absolute ${bgColor} ${className}`} style={{
    width: size,
    height: size
  }} animate={{
    rotate: 360
  }} transition={{
    duration: 20,
    repeat: Infinity,
    ease: 'linear',
    delay
  }} data-id="element-134" />;
};
export const FloatingTriangle = ({
  className = '',
  color = 'navy',
  size = 100
}: ShapeProps) => {
  const borderColor = color === 'coral' ? 'border-b-coral' : 'border-b-navy';
  return <motion.div className={`absolute w-0 h-0 border-l-[50px] border-r-[50px] border-b-[86.6px] border-l-transparent border-r-transparent ${borderColor} ${className}`} style={{
    width: 0,
    height: 0,
    borderLeftWidth: size / 2,
    borderRightWidth: size / 2,
    borderBottomWidth: size * 0.866
  }} animate={{
    y: [0, -20, 0],
    rotate: [0, 5, 0]
  }} transition={{
    duration: 6,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-135" />;
};
export const ParallaxCircle = ({
  className = '',
  color = 'coral',
  size = 100,
  speed = 1
}: ShapeProps & {
  speed?: number;
}) => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [0, -100 * speed]);
  const bgColor = color === 'coral' ? 'bg-coral' : color === 'navy' ? 'bg-navy' : 'bg-white';
  return <motion.div ref={ref} style={{
    y,
    width: size,
    height: size
  }} className={`absolute rounded-full ${bgColor} ${className}`} data-id="element-136" />;
};
export const GridBackground = () => <div className="absolute inset-0 -z-10 h-full w-full bg-white bg-grid-pattern opacity-40 pointer-events-none" data-id="element-137" />;